// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination___24URT","active":"active___8hSPG","button":"button___2RnaP","disabled":"disabled___EH8iX"};